import React from 'react';
import { Alert } from '@economic/taco';
import { Trans, t } from '@lingui/macro';

import SignupForm from '../../SignupForm';
import Illustration from '../../../../../../assets/economic-nf-puzzle-piece.gif';

const Success = ({ closeDialog }) => {
    return (
        <SignupForm onNext={closeDialog}>
            <div className="flex justify-center">
                <img src={Illustration} className="h-64" />
            </div>

            <div className="my-4">
                <Trans>
                    When you click "Continue", we will forward you to our partner November First, where you must upload
                    documentation to be approved to use Smart Pay.
                </Trans>
            </div>
            <Alert state="information" className="my-2" title={t`Check your email: Confirmation code`}>
                <Trans>
                    November First has sent you an email with a confirmation code that you will use in the next step. Remember to
                    check your spam folder
                </Trans>
            </Alert>
        </SignupForm>
    );
};

export default Success;
